"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bubble = exports.List = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.List = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexWrap: "wrap",
    variants: {
        hasTooltip: {
            true: {
                width: "100%",
            },
        },
    },
});
exports.Bubble = (0, stitches_config_1.styled)("div", {
    border: stitches_config_1.borderStyles.solid,
    borderRadius: stitches_config_1.cornerRadius.radiusXl,
    fontSize: stitches_config_1.fontSizes.body4,
    cursor: "pointer",
    padding: "5px 10px",
    marginRight: "10px",
    marginBottom: "7px",
    variants: {
        selected: {
            true: {
                backgroundColor: stitches_config_1.colors.blue500,
                color: stitches_config_1.colors.contentPrimaryInverted,
                "&:hover": {
                    backgroundColor: stitches_config_1.colors.blue500,
                },
            },
        },
        disabled: {
            true: {
                cursor: "default",
            },
        },
        readonly: {
            true: {
                cursor: "default",
            },
        },
    },
    compoundVariants: [
        {
            selected: false,
            readonly: true,
            css: {
                opacity: "60%",
            },
        },
        {
            disabled: true,
            readonly: false,
            css: {
                opacity: "60%",
            },
        },
    ],
});
//# sourceMappingURL=data:application/json;base64,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